/** Catalog service codes — keep in sync with backend ServiceEntity.serviceCode */
export const SERVICE_CODES = {
  PAYROLL: '111',
  CONTRACT: '222',
  SYSTEM_REGISTER: '333',
};

/** Dropdown options for catalog add/edit service dialogs */
export const SERVICE_CODE_OPTIONS = [
  { label: 'Payroll', value: SERVICE_CODES.PAYROLL },
  { label: 'Contract', value: SERVICE_CODES.CONTRACT },
  { label: 'IT Governance', value: SERVICE_CODES.SYSTEM_REGISTER },
];

export const SERVICE_PATHS = {
  [SERVICE_CODES.PAYROLL]: '/payroll',
  [SERVICE_CODES.CONTRACT]: '/contract',
  [SERVICE_CODES.SYSTEM_REGISTER]: '/system-register',
};
